import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Bandage"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-bandage',
    templateUrl: './icon-bandage.component.html',
    styleUrls: ['./icon-bandage.component.scss'],
    standalone: false
})
export class IconBandageComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
